import React from "react";

import { OverflowTooltip } from "components";
import { Application, TableCellProp } from "types";

const proseccorSponsorColumn = () => ({
	Header: "Processor / Sponsor",
	accessor: "processorSponsor",
	disableSortBy: true,
	Cell: ({ row: { original } }: TableCellProp<Application>) => {
		let processorSponsor = `${original?.processor || ""} / ${
			original?.sponsor || ""
		}`;
		if (processorSponsor === " / ") {
			processorSponsor = "";
		}
		return (
			<OverflowTooltip onlyOnLaptop title={processorSponsor}>
				{processorSponsor}
			</OverflowTooltip>
		);
	},
});

export default proseccorSponsorColumn;
